import affirm from '../../../core/Affirm'
import Helper from '../../../helpers/Helper'
import { Cell, Column, Row } from './SmartTableDefinitions'

const SmartTableUtilities = {
    extrapolateRows: <T extends object>(columns: Column<T>[], items: T[]): Row[] => {
        affirm(columns, 'Invalid columns')
        affirm(items, 'Invalid items')

        const format = (c: Column<T>, value: any) => {
            switch (c.type) {
                case 'array':
                    if (Array.isArray(value)) {
                        return value.join(', ')
                    } else if (value) {
                        return value.toString()
                    } else {
                        return ''
                    }
                case 'date':
                    return value ? new Date(value).toLocaleDateString() : ''
                default:
                    return value ?? ''
            }
        }

        return items.map((item, i) => ({ _index: i, cells: columns.map(col => ({ value: format(col, Helper.getNestedValue(item, col.id)) }) as Cell) }) as Row)
    },
    toRows: (cells: Cell[][]): Row[] => {
        return cells.map((x, i) => ({ _index: i, cells: x }))
    },
    toRow: (cells: Cell[], i: number, subContent?: Row['subContent']): Row => ({ _index: i, cells, subContent })
}

export default SmartTableUtilities
